<template>
    <div class="bg-black white relative">
        <img v-if="screenSize === 'xs' || screenSize === 'sm'" class="absolute" style="top: -130px; margin-left:auto; margin-right:auto; left:0; right:0;" src="@/assets/img/landing/section5_larry_with_money.svg">
        <div class="container" :style="screenSize === 'xs' || screenSize === 'sm' ? 'padding-top: 370px;' : '' ">
            <div v-if="screenSize === 'md' || screenSize === 'lg'" class="col-xs-6 relative">
                
                <img class="absolute" style="top: -150px; margin-left:auto; margin-right:auto; left:0; right:0;" src="@/assets/img/landing/section5_larry_with_money.svg">
            </div>
            <div class="col-xs-12 col-md-6 col-md-offset-6 tc tl-m" style="padding-top:128px; padding-bottom:128px;">
                <h2>Wish you could earn money for doing nothing?</h2>
                <div class="bodyCopy mt3 mb4">Earn passive income by listing your unused tools on Tooliaba. You can trust your tools will
                    be in good hands with safety deposits and insurance. You have nothing to lose and so much to gain!
                </div>
                <router-link to="listing-start" class="no-underline">
                    <TooliabaButton class="w-100 w-50-m">List My Tools</TooliabaButton>
                </router-link>
            </div>
            
        </div>
    </div>
</template>

<script>
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        TooliabaButton
    },
    computed: {
        screenSize() {
            return this.$mq;
        }
    }
};
</script>
